const listaDeTiposServico = (state) => {
    if (!state.items || !Array.isArray(state.items)) {
        return [];
    }
    return state.items;
}

const loadingTiposServico = (state) => {
    return state.carregando
}

export {
    listaDeTiposServico,
    loadingTiposServico
}
